"use client";

import React from "react";
import { Search } from "@platzi/icons";
import { isAValidEmail } from "@/utils/isAValidEmail";
import { Tag } from "./Tag";
import styles from "./TagInput.module.sass";

interface TagsInputProps {
  id?: string;
  tag: string;
  setTag: (value: string) => void;
  placeholder?: string;
  customClass?: string;
  inputValue: string;
  setInputValue: (value: string) => void;
  cleanRecommendations?: () => void;
}

export const TagsInput = (props: TagsInputProps) => {
  const {
    id,
    tag,
    setTag,
    placeholder,
    customClass = "",
    inputValue,
    setInputValue,
    cleanRecommendations = () => {},
  } = props;

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === ";" || e.key === " ") {
      e.preventDefault();
      const trimmedValue = inputValue.trim();
      if (trimmedValue !== "" && isAValidEmail(trimmedValue)) {
        setTag(trimmedValue);
        setInputValue("");
        cleanRecommendations();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData("Text");
    const newTags = pastedData.split(/[\t\n,;]/).filter((tag) => tag.trim() !== "");
    const validedTags = newTags.filter((tag) => isAValidEmail(tag));

    if (newTags?.length > 0) {
      setTag(validedTags[0]);
      setInputValue("");
      cleanRecommendations();
    }
  };

  const handleTagRemove = () => {
    setTag("");
    cleanRecommendations();
  };

  return (
    <div className={`${styles.TagInput} ${customClass}`}>
      <Search />
      {tag ? (
        <Tag handleTagRemove={handleTagRemove} tag={tag} />
      ) : (
        <input
          id={id}
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onKeyPress={handleInputKeyPress}
          onPaste={handlePaste}
          data-qa="tags-input"
        />
      )}
    </div>
  );
};
